<template>
  <div class="magnit-hero">
    <div class="magnit-hero__textbox">
      <div class="magnit-hero__headline">
        <img
          src="/theme/rbFront/img/w/magnit/contents/LG-MAGNIT-logo.png"
          alt="LG Magnit"
        />
      </div>
      <div class="magnit-hero__bodycopy">
        MICRO IN SIZE, <br class="br-mobile" />MAGNIFICENT IN ITS POSSIBILITIES
      </div>
    </div>
    <div class="magnit-hero__media-wrapper">
      <img
        src="/theme/rbFront/img/w/magnit/contents/LG-MAGNIT-Hero-PC.jpg"
        class="magnit-hero__media magnit-hero__media--pc"
        alt="PC Image"
      />
      <img
        src="/theme/rbFront/img/w/magnit/contents/LG-MAGNIT-Hero-M.jpg"
        class="magnit-hero__media magnit-hero__media--mobile"
        alt="Mobile Image"
      />
    </div>
    <div class="magnit-hero__eyebrow">
      * All Images simulated for illustrative purposes only.
      <br class="br-mobile" />Actual performance may vary.
    </div>
  </div>
</template>
<script>
export default {
  name: 'Hero',
  props: {
    minHeight: {
      type: Number,
      required: false,
      default: 603,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
@import '@/scss/helper.scss';
.magnit-hero {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  &__textbox {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 23px;
    position: absolute;
    top: 57px;
    left: 50%;
    transform: translateX(-50%);
  }
  &__bodycopy {
    font-size: 24px;
    font-weight: 400;
    color: #000;
  }
  &__media-wrapper {
    max-width: 1800px;
    margin: 0 auto;
    min-height: 300px;
    font-size: 0;
    @media screen and (max-width: 1080px) {
      min-height: 300px;
    }
  }
  &__media {
    width: 100%;
    &--mobile {
      display: none;
    }
    @media screen and (max-width: 1080px) {
      &--pc {
        display: none;
      }
      &--mobile {
        display: inline;
      }
    }
  }
  &__eyebrow {
    max-width: 1440px;
    width: 1440px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    font-size: 16px;
    font-weight: 400;
    color: #000;
  }
  @media screen and (max-width: 1080px) {
    &__textbox {
      box-sizing: border-box;
      padding: 0 calcQuarter(60);
      width: 100%;
      gap: calcQuarter(97);
      top: calcQuarter(211);
    }
    &__headline {
      img {
        width: calcQuarter(755);
      }
    }
    &__bodycopy {
      font-size: calcQuarter(64);
      line-height: calcQuarter(74);
    }
    &__eyebrow {
      width: 100%;
      text-align: right;
      font-size: calcQuarter(48);
      line-height: calcQuarter(56);
      padding: 0 calcQuarter(60) 0 70px;
      box-sizing: border-box;
    }
  }
}
</style>
